export default {
    namespaced: true,
    state: {
        nodeIdList: null
    },
    mutations: {
        setNodeIdList(state, list) {
            state.nodeIdList = list
        },
        addNoteId(state, Id) {
            if (!state.nodeIdList) {
                state.nodeIdList = []
            }
            state.nodeIdList.push(Id)
        },
        removeNoteId(state, Id) {
            if (state.nodeIdList) {
                let key = state.nodeIdList.indexOf(Id)
                if (key !== -1) {
                    state.nodeIdList.splice(key, 1)
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/note.js